import React from "react";
import { TextAreaInput } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import { useChannelInfoOptions } from "./ChannelContext";

const EditChannelDescription = () => {
  const {
    channelDescription,
    handleChannelInfoChange,
  } = useChannelInfoOptions();
  const { t } = useI18n(["common"]);

  const setChannelDescription = e => {
    handleChannelInfoChange({ channelDescription: e.target.value });
  };

  return (
    <TextAreaInput
      label={t("common:description")}
      name="description"
      size={"medium"}
      placeholder={t("common:enter_with_label", {
        label: t("common:description"),
      })}
      value={channelDescription}
      onChange={setChannelDescription}
      maxRows={2}
      dsVersion="2.0"
    />
  );
};

export default EditChannelDescription;
